import { NotificationProgrammatic as Notification } from 'buefy/dist/components/notification';
import Axios from 'axios';
import config from '@/config';
import store from '@/store';
import router from '@/router';

export default {
  install: (Vue) => {
    // const ReasignVue = Vue;
    // ReasignVue.prototype.$http = axios;
    const axios = Axios.create({
      withCredentials: true,
      baseURL: config.api.baseURL
    });
    // Add a request interceptor
    axios.interceptors.request.use((requestConfig) => {
      const wRequestConfig = requestConfig;
      // wRequestConfig.headers.Authorization = store.state.bearer;
      return wRequestConfig;
    }, error => Promise.reject(error));

    // Add a response interceptor
    axios.interceptors.response.use((response) => {
      if (response && response.data && response.data.data && response.data.data.token) {
        store.commit('setBearer', response.data.data.token);
      }
      if (response && response.data && response.data.data && response.data.data.request) {
        axios.post('notification/request', {
          request: response.data.data.request
        });
      }
      return response;
    }, (error) => {
      Notification.open({
        duration: 5000,
        message: `Something's not good ${error}`,
        position: 'is-bottom',
        type: 'is-danger'
      });
      if (error.response) {
        router.push('/');
      }
    });

    Object.defineProperties(Vue.prototype, {
      axios: {
        get () {
          return axios;
        }
      },

      $http: {
        get () {
          return axios;
        }
      }

    });
  }
};



// WEBPACK FOOTER //
// ./src/custom/axios-plugin.js